import * as React from 'react';
import s from './PageFooter.scss';
import classNames from 'classnames';
import { withInjectedRootStore, RootStore } from 'providers';
import { useTranslation } from 'react-i18next';
import { AcceptedPaymentMethodIcons } from './AcceptedPaymentMethodIcons';
import { Text } from 'wix-style-react';
import { getPaymentMethodsFromDealerOffers } from 'utils';
import { CardBrands } from 'src/constants';

export interface AcceptedPaymentMethodsProps {
  rootStore: RootStore;
}

const AcceptedPaymentMethodsComp: React.FunctionComponent<AcceptedPaymentMethodsProps> = ({
  rootStore,
}) => {
  const { t } = useTranslation();
  const { parsedDealerOffers } = rootStore.appStore.appContext;
  const paymentMethods = getPaymentMethodsFromDealerOffers(
    parsedDealerOffers,
  ) as CardBrands[];
  return (
    <div className={s.singleElementWrapper}>
      <div className={classNames(s.singleElement, s.first)}>
        <Text weight='bold' size='tiny' className={s.title} tagName='p'>
          {t('page_footer.accepted_payment_methods')}
        </Text>
        <AcceptedPaymentMethodIcons paymentMethods={paymentMethods} />
      </div>
    </div>
  );
};

export const AcceptedPaymentMethods = withInjectedRootStore(
  AcceptedPaymentMethodsComp,
);
